<template>
  <div>
    <List
      url="structures/"
      :title="title"
      titleClass="title"
      :tanle="tanle"
      :operat="operat"
      :data="searchData"
      :update="updateList"
      :afterList="dealList"
      @edit="edit"
      @deletedata="deletedata"
    >
      <div slot="Filter" style="display: flex;line-height:30px;">
        <label>组织架构名称：</label>
        <el-input
          v-model="searchData.name"
          style="width:200px;margin-right:30px;"
        ></el-input>
        <el-button @click="updateList++" type="primary" size="small"
          >搜索</el-button
        >
      </div>
      <template slot="Fresh">
        <el-button
          @click="add"
          type="primary"
          style="margin-bottom:10px;float:right"
          >新增</el-button
        >
      </template>
    </List>
    <UpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
    ></UpdateBox>
  </div>
</template>
<script>
import List from "../components/common/List.vue";
import UpdateBox from "../components/Organizational/UpdateBox.vue";

export default {
  components: {
    List,
    UpdateBox
  },
  data() {
    return {
      tanle: [
        { name: "name", label: "名称" },
        { name: "parentName", label: "上级部门" }
      ],
      title: "组织架构",
      operat: [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],
      searchData: {
        name: ""
      },
      updateType: "edit",
      updateList: 0,
      updateBlock: false,
      updateForm: {}
    };
  },
  computed: {
    departmentGroup() {
      let departmentGroup = this.$store.state.departmentGroup;
      return departmentGroup;
    }
  },
  methods: {
    dealList(data) {
      for (let i in data) {
        if (data[i].parent) {
          for (let j in this.departmentGroup) {
            if (data[i].parent == this.departmentGroup[j].ID) {
              data[i].parentName = this.departmentGroup[j].Name;
            }
          }
        }
      }
      return data;
    },
    edit(val) {
      this.updateBlock = true;
      this.updateType = "edit";
      this.updateForm = Object.assign({}, val);
    },
    add() {
      this.updateBlock = true;
      this.updateType = "add";
      this.updateForm = {};
    },
    deletedata(val) {
      let url = "structures/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    close() {
      this.updateBlock = false;
    }
  }
};
</script>
